import React, { useEffect, useLayoutEffect, useState } from "react";
import { useStore } from "react-redux";
import { useMedia } from "use-media";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import common from "../../resources_catalog/js/common/common";
import ico_more from "../../resources_catalog/icons/ico_more.svg";
import ico_minus from "../../resources_catalog/icons/ico_minus.svg";
import anchor_blank from "../../resources_catalog/icons/anchor_blank.svg";
import hotel_img_jp_1 from "../../resources_catalog/images/hotelLineupJp/hotel_jp_1.jpg";
import hotel_img_jp_2 from "../../resources_catalog/images/hotelLineupJp/hotel_jp_2.jpg";
import hotel_img_jp_3 from "../../resources_catalog/images/hotelLineupJp/hotel_jp_3.jpeg";
import hotel_img_jp_4 from "../../resources_catalog/images/hotelLineupJp/hotel_jp_4.jpeg";
import hotel_img_jp_5 from "../../resources_catalog/images/hotelLineupJp/hotel_jp_5.jpg";
import commonUtil from "../../common/commonUtil";
import { getAreaList, getCityListByCountry, getCountryListByArea, getHotelList } from '../../const/RTCC/index.js';
import { PullDown } from "../../components/atoms/RTCC/pullDown";
import { Button } from "../../components/atoms/RTCC/button";
import Const from "../../const/RTCC/Const";
import { useRtoaster } from "../../hooks/useRtoaster";

export const CatalogLineupJpContainer = (props) => {
  const isWidePhone = useMedia({ maxWidth: "480px" });
  const isWideTablet = useMedia({ maxWidth: "960px" });

  const store = useStore();
  // レスポンス設定リスト
  const [dispHotelList, setDispHotelList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [reserveAreaList, setReserveAreaList] = useState([]);
  const [reserveCountryList, setReserveCountryList] = useState([]);
  const [reserveCityList, setReserveCityList] = useState([]);
  const [displayAllHotelFlg, setDisplayAllHotelFlg] = useState(false);
  const [linkList, setLinkList] = useState([]);
  const [searchFlg, setSearchFlg] = useState(false);
  let hotelInfo = {};

  const [hotelImageList, setHotelImageList] = useState([
    { propertyImages: hotel_img_jp_1 },
    { propertyImages: hotel_img_jp_2 },
    { propertyImages: hotel_img_jp_3 },
    { propertyImages: hotel_img_jp_4 },
    { propertyImages: hotel_img_jp_5 },
  ]);

  // const history = require("history").createBrowserHistory()
  const history = useHistory()

  // rtoasterタグ生成
  useRtoaster();

  //この関数は画面レンダリング前に動きます
  useLayoutEffect(() => {
  })

  //この関数は画面レンダリング後に動きます
  useEffect(() => {
    // エリア取得リクエスト
    common.doPost(getAreaList, {}, afterGetArea);
    //  ホテル取得リクエスト
    common.doPost(getHotelList, {}, afterGetHotelList);

    setLinkList([{ path: "/rtcc/catalog/home", label: "ホーム" }]);
  }, []);

  

  // ホテル一覧取得後処理
  const afterGetHotelList = (res) => {
    if (res.data) {
      let domesticDataList = [];
      //　国内取得
      res.data.domesticHotelListInfo.map((value) => {
        let data = {
          propertyImages: value.propertyImages,
          areaId: value.areaId,
          countryId: value.countryId,
          cityId: value.cityId,
          cityName: value.cityName,
          hotelName: value.hotelName
        };
        domesticDataList.push(data);
      });
      setDispHotelList(domesticDataList);
    }
  };

  // ホテル絞り込み後処理
  const afterSearchHotelList = (res) => {
    if (res.data) {
      let domesticDataList = [];
      //　国内取得
      if (res.data.domesticHotelListInfo) {
        res.data.domesticHotelListInfo.forEach((value) => {
          let data = {
            propertyImages: value.propertyImages,
            areaId: value.areaId,
            countryId: value.countryId,
            cityId: value.cityId,
            cityName: value.cityName,
            hotelName: value.hotelName
          };
          domesticDataList.push(data);
        });
      }
      setDispHotelList(domesticDataList);
      document.getElementById("resultArea").scrollIntoView({ behavior: "smooth" });
      if (countryList?.length) {
        setReserveCountryList(commonUtil.getCheckList(countryList.filter((country, index) => index != 0), "value", "option", false));
      }
      if (cityList?.length) {
        setReserveCityList(commonUtil.getCheckList(cityList.filter((city, index) => index != 0), "value", "option", false));
      }

    }
  };
  // エリア一覧取得後処理
  const afterGetArea = (res) => {
    const data = res.data;
    if (data.resultCode != 0) {
      console.log(data.errorMessage);
      return;
    }
    let areas = [];
    if (res.data.areaList) {
      areas = res.data.areaList.filter(value => {
        return value.areaId != "1"
      });
    }
    // リスト作成
    let selectList = [{ value: "", option: "指定なし" }];
    areas.forEach((info) => {
      let obj = { value: info["areaId"], option: info["areaName"] };
      selectList.push(obj);
    });
    let radioList = commonUtil.getRadioList(areas, "areaId", "areaName", false);
    setAreaList(selectList);
    setReserveAreaList(radioList);
  }

  const afterGetCountryList = (res) => {
    let data = res.data;
    let selectList = [{ value: "", option: "指定なし" }];
    let checkList = [];
    if (data.resultCode == 0) {
      // リスト作成
      if (data.countryList && data.countryList.length != 0) {
        data.countryList.forEach((info) => {
          let obj = { value: info["countryId"], option: info["countryName"] };
          selectList.push(obj);
        });
        checkList = commonUtil.getCheckList(data.countryList, "countryId", "countryName", false);
      }
    }
    setCountryList(selectList);
    setCityList([{ value: "", option: "指定なし" }]);
  }
  // 都市一覧取得後処理
  const afterGetCityList = (res) => {
    let data = res.data;
    let selectList = [{ value: "", option: "指定なし" }];
    let checkList = [];
    if (data.resultCode == 0) {
      // リスト作成
      if (data.cityList) {
        data.cityList.forEach((info) => {
          let obj = { value: info["cityId"], option: info["cityName"] };
          selectList.push(obj);
        });
        checkList = commonUtil.getCheckList(data.cityList, "cityId", "cityName", false);
      }
    }
    setCityList(selectList);

  }
  // エリア選択
  const onChangeArea = (e) => {
    let areaId = e.target.value;
    common.doPost(getCountryListByArea, { areaId: areaId }, afterGetCountryList)
  }
  // 国選択
  const onChangeCountry = (e) => {
    let countryId = e.target.value;
    common.doPost(getCityListByCountry, { countryId: [countryId] }, afterGetCityList)
  }

  const onClickSearch = () => {
    let areaId = document.getElementById("areaList").value;
    let countryId = document.getElementById("countryList").value;
    let cityId = document.getElementById("cityList").value;
    if (areaId != "") {
      setSearchFlg(true);
      common.doPost(getHotelList, { domesticFlg: "Y", areaId: areaId, countryId: countryId, cityId: cityId }, afterSearchHotelList);
    } else {
      common.doPost(getHotelList, {}, afterSearchHotelList);
    }
  }
  // 「予約する」押下時の国一覧取得取得後処理
  const setCountryCheckList = (res) => {
    let data = res.data;
    let checkList = [];
    if (data.resultCode == 0) {
      // リスト作成
      if (data.countryList && data.countryList.length != 0) {
        checkList = commonUtil.getCheckList(data.countryList, "countryId", "countryName", false);
      }
    }
    checkList.forEach((country) => {
      if (country.value == hotelInfo.countryId) {
        country.checked = true;
        store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: country.label } });
      }
    })
    store.dispatch({ type: "COUNTRY", payload: { country: checkList } });
  }
  // 「予約する」押下時の都市一覧取得取得後処理
  const setCityCheckList = (res) => {
    let data = res.data;
    let checkList = [];
    if (data.resultCode == 0) {
      // リスト作成
      if (data.cityList && data.cityList.length != 0) {
        checkList = commonUtil.getCheckList(data.cityList, "cityId", "cityName", false);
      }
    }
    checkList.forEach((city) => {
      if (city.value == hotelInfo.cityId) {
        city.checked = true;
        store.dispatch({ type: "DISP_CITY", payload: { dispCity: city.label } });
      }
    })
    store.dispatch({ type: "CITY", payload: { city: checkList } });
  }
  // 予約する
  const onClickReserve = (hotel) => {
    reserveAreaList.forEach((area) => {
      if (area.value == hotel.areaId) {
        area.checked = true;
        store.dispatch({ type: "DISP_AREA", payload: { dispArea: area.text } });
      }
    });
    hotelInfo = hotel;
    if (searchFlg) {
      if (reserveCountryList?.length) {
        reserveCountryList.forEach((country) => {
          if (country.value == hotel.countryId) {
            country.checked = true;
            store.dispatch({ type: "DISP_COUNTRY", payload: { dispCountry: country.label } });
          }
        });
        store.dispatch({ type: "COUNTRY", payload: { country: reserveCountryList } });
      } else {
        common.doPost(getCountryListByArea, { areaId: hotelInfo.areaId }, setCountryCheckList);
      }
      if (reserveCityList?.length) {
        reserveCityList.forEach((city) => {
          if (city.value == hotel.cityId) {
            city.checked = true;
            store.dispatch({ type: "DISP_CITY", payload: { dispCity: city.label } });
          }
        });
        store.dispatch({ type: "CITY", payload: { city: reserveCityList } });
      } else {
        common.doPost(getCityListByCountry, { countryId: [hotelInfo.countryId] }, setCityCheckList);
      }
    } else {
      common.doPost(getCountryListByArea, { areaId: hotelInfo.areaId }, setCountryCheckList);
      common.doPost(getCityListByCountry, { countryId: [hotelInfo.countryId] }, setCityCheckList);
    }

    store.dispatch({ type: "AREA", payload: { area: reserveAreaList } });
    store.dispatch({ type: "KEYWORD", payload: { keyWord: hotel.hotelName } })
    store.dispatch({ type: "CATALOG_FLG", payload: { catalogFlg: true } });
    store.dispatch({ type: "RTCC_FLG", payload: { rtccFlg: true } });
    history.push("/reserve/rtcc/reservation");
  }

  // 表示ホテル数変更
  const handleChangeDispNum = () => {
    setDisplayAllHotelFlg(!displayAllHotelFlg);
  }

  const onErrorImage = (target) => {
    let newList = dispHotelList.filter((hotel, index) => index != target);
    setDispHotelList(newList);
  }

  const settings3 = {
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    variableWidth: true,
  };

  return (
    <div className="catalogLineupWrap">
      <div className="catalogLineup">
        <div className="hotelLineUpListSlider">
          <div className="catalogLineupBox">
            <div className="catalogLineupJpSlideTitle">
              <p className="catalogLineupSlideTitleText">RTCC宿泊<br />ホテルラインナップ<br />(国内・海外手配旅行)</p>
              <p className="catalogLineupSlideTitleCaption">RTCC HOTEL LINE UP</p>
            </div>
          </div>

          <Slider {...settings3}>
            {
              hotelImageList.map((data, index) => (
                <div key={"hotel" + index} className="hotelLineUpListSlideWrap">
                  <div className="hotelLineUpListSlide">
                    <img src={data.propertyImages} alt="" className="hotelLineUpImgSlide" />
                  </div>
                </div>
              ))
            }
          </Slider>
        </div>

        <div className="hotelLineUpListSearch">
          <div className="hotelLineUpListSearchInner">
            <div className="hotelLineUpListSearchInnerBox">
            <div className="hotelLineUpListSearchContent">
                <p>エリアを選択</p>
                <PullDown
                  id="areaList"
                  class="hotelLineUpListSearchContentList"
                  data={areaList}
                  onChange={onChangeArea}
                />
              </div>
              <div className="hotelLineUpListSearchContent">
                <p>国を選択</p>
                <PullDown
                  id="countryList"
                  class="hotelLineUpListSearchContentList"
                  data={countryList}
                  disabled={countryList.length < 2}
                  onChange={onChangeCountry}
                />
              </div>
              <div className="hotelLineUpListSearchContent">
                <p>都市を選択</p>
                <PullDown
                  id="cityList"
                  class="hotelLineUpListSearchContentList"
                  disabled={cityList.length < 2}
                  data={cityList}
                />
              </div>
              <div className="hotelLineUpListSearchButton">
                <Button buttonText="この条件で絞り込む" className={isWideTablet ? "btnReservationSp" : "searchBtnCatalog"} onClick={onClickSearch} buttonClassName="serachBtnText" />
              </div>
            </div>
          </div>
        </div>
        <div className="catalogLineupAttention">
        <p className="catalogLineupAttentionTitle">【ご注意情報】</p>
          <p className="catalogLineupAttentionText">各都道府県において、感染レベルの引き上げや緊急事態宣言等の発令がありますので、お客様ご自身でご確認の上、お申込み下さい。</p>
          <p className="">海外のホテルをご利用の場合、掲載施設の国・地域における感染症危険情報、危険情報につきましては、外務省の海外安全ホームページでご確認ください。</p>
          <a href="https://www.anzen.mofa.go.jp/" className="hotelLineUpHome" target="_blank" rel="noopener noreferrer">
            <p>外務省海外安全ホームページ</p>
            <img src={anchor_blank} alt="" className="anchor_icon" />
          </a>
        </div>
        <div id="resultArea" className="catalogLineupHotelFacilitiesWrap">
          <p className="catalogLineupHotelFacilities">該当施設：</p>
          <p className="catalogLineupHotelFacilitiesCount"><span>{dispHotelList.length}</span>件</p>
        </div>
        <div className="catalogLineupHotelListWrap">
          {
            displayAllHotelFlg ? dispHotelList.map((hotel, hotelIndex) => (
              <div key={"hotel" + hotelIndex} className="catalogLineupHotelList">
                <img src={hotel.propertyImages} onError={() => onErrorImage(hotelIndex)} style={{ display: "none" }} />
                <div className="catalogLineupImgWrap">
                  <img src={hotel.propertyImages} alt="" className="catalogLineupImg" />
                </div>
                <p className="catalogLineupPlace">{hotel.cityName}</p>
                <p className="catalogLineupName">{hotel.hotelName}</p>
                <Button className="reserveBtnCatalog" onClick={() => onClickReserve(hotel)} buttonText="予約する" />
              </div>
            )) :
              dispHotelList.filter((data, index) => index < Const.MAX_DISP_NUM).map((hotel, hotelIndex) => (
                <div key={"hotel" + hotelIndex} className="catalogLineupHotelList">
                  <img src={hotel.propertyImages}  style={{ display: "none" }} />
                  <div className="catalogLineupImgWrap">
                    <img src={hotel.propertyImages} alt="" className="catalogLineupImg" />
                  </div>
                  <p className="catalogLineupPlace">{hotel.cityName}</p>
                  <p className="catalogLineupName">{hotel.hotelName}</p>
                  <Button className="reserveBtnCatalog" onClick={() => onClickReserve(hotel)} buttonText="予約する" />
                </div>
              ))
          }
        </div>
        {/* {
          <div className="catalogLineupJpHotelListWrap">
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
            <div className="catalogLineupJpHotelList">
              <div className="catalogLineupJpImgWrap">
                <img src={hotel_img_jp_1} alt="" className="catalogLineupJpImg" />
              </div>
              <p className="catalogLineupJpPlace">あああああ</p>
              <p className="catalogLineupJpName">あああああ</p>
              <Button className="reserveBtnCatalog" onClick={() => onClickReserve()} buttonText="予約する" />
            </div>
          </div>
        } */}
        <div className={dispHotelList && dispHotelList.length <= Const.MAX_DISP_NUM ? "hiddenItem" : "catalogNewsAllMore"} onClick={handleChangeDispNum}>
          {displayAllHotelFlg ? <>
            <img src={ico_minus} alt="" className="catalogNewsAllListImgAllMore" />
            <p>表示数を戻す</p>
          </>
            : <>
              <img src={ico_more} alt="" className="catalogNewsAllListImgAllMore" />
              <p>もっと見る</p>
            </>
          }
        </div>
        <div className={isWideTablet ? "none" : "catalogBreadCrumb"}>
          {linkList.map((value, index) => (
            <div key={"link" + index} style={{ display: "flex" }}>
              <Link to={value.path} className="link">{value.label}</Link>
              <div className="lastLabel">&gt;</div>
            </div>
          ))}
          <div className="lastLabel">RTCC宿泊ホテルラインナップ(国内・海外手配旅行)</div>
        </div>
      </div>
    </div>
  );
};